module.exports = __webpack_public_path__ + "img/ball_5.df9fcb92.png";